import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Box, LinearProgress, Typography } from "@material-ui/core";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./styles";

class ProgressBar extends React.Component {
	render() {
		let { classes, progress } = this.props;
		let isLoaded = false;
		if (!progress) {
			progress = 0;
		}
		if (progress === 100) {
			isLoaded = true;
		}

		return (
			<div
				style={{
					display: isLoaded ? "none" : "block"
				}}
				className={classes.container}
			>
				<Box className={classes.label}>Chargement...</Box>
				<Box display="flex" position="relative" alignItems="center">
					<Box width="100%">
						<LinearProgress
							variant="determinate"
							color="primary"
							classes={classes}
							value={progress}
						/>
					</Box>
					{/* <Box className={classes.progress}>
                        {`${Math.round(progress,)}%`}
                    </Box> */}
				</Box>
			</div>
		);
	}
}

ProgressBar.propTypes = {
	classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(ProgressBar)
);
